import { gsap } from "gsap";
    
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

//when campaign-progress-box scrolls into view
//set width of progress-bar__fill based on data-width attribute
gsap.utils.toArray(".campaign-progress-box").forEach((box) => {
    ScrollTrigger.create({
        trigger: box,
        start: "top center",
        onEnter: () => {
            const fill = box.querySelector(".progress-bar__fill");
            if (fill) {
                gsap.to(fill, {
                    width: fill.dataset.width + "%",
                    duration: 1
                });
            }
        }
    });
});